/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type {
  DeleteProjectResponse,
  IdResponse,
  PagedProjectListResponse,
  ProjectAgentChatThreadDetailResponse,
  ProjectAgentChatThreadListResponse,
  ProjectAgentChatTurnDetailResponse,
  ProjectCreateResponse,
  ProjectDetailResponse,
  ProjectEucsListResponse,
  ProjectListQueryStoreDetailResponse,
  ProjectMemoDetailResponse,
  ProjectMemoListResponse,
  ProjectReferenceChatDetailResponse,
  ProjectReferenceMatchDetailResponse,
  ProjectReferenceMatchDocumentRecordListResponse,
  ProjectsOptionsResponse,
  ProjectUpdateResponse,
  SuccessResponse,
} from './model';
import { EucDataType, ProjectSourceType, ReferenceChatType } from './model';

export const getGetProjectsResponseMock = (): PagedProjectListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        accounting_type: faker.helpers.arrayElement([
          {
            id: faker.string.uuid(),
            code: faker.string.alpha({ length: { min: 10, max: 50 } }),
            name: faker.string.alpha({ length: { min: 10, max: 255 } }),
            year: faker.number.int({ min: 1900, max: 2100 }),
          },
          undefined,
        ]),
        kan: {
          id: faker.string.uuid(),
          accounting_type_id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        },
        ko: {
          id: faker.string.uuid(),
          kan_id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        },
        moku: {
          id: faker.string.uuid(),
          ko_id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        },
        saimoku_code: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 50 } }),
          undefined,
        ]),
        saimoku_name: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 255 } }),
          undefined,
        ]),
        saisaimoku_code: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 50 } }),
          undefined,
        ]),
        saisaimoku_name: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 255 } }),
          undefined,
        ]),
        project_code: faker.string.alpha({ length: { min: 10, max: 50 } }),
        project_name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        budget_management_division: {
          id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
          year: faker.number.int({ min: 1900, max: 2100 }),
        },
        budget_amount: faker.number.int({ min: undefined, max: undefined }),
        year: faker.number.int({ min: 1900, max: 2100 }),
        created_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
        updated_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
        display_created_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
        tags: faker.helpers.arrayElement([
          Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
            () => ({
              id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
              name: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
            }),
          ),
          undefined,
        ]),
        reference_chats: faker.helpers.arrayElement([
          Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
            () => ({
              id: faker.string.uuid(),
              type: faker.helpers.arrayElement(Object.values(ReferenceChatType)),
              completion: faker.string.alpha({ length: { min: 10, max: 20 } }),
            }),
          ),
          undefined,
        ]),
        reference_matches: faker.helpers.arrayElement([
          Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
            () => ({
              reference_match_id: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                null,
              ]),
              reference_chat_type: faker.helpers.arrayElement(Object.values(ReferenceChatType)),
              status: faker.helpers.arrayElement([
                'idle',
                'pending',
                'generating',
                'completed',
                'failed',
                'deleted',
              ] as const),
              converse_count: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              documents: faker.helpers.arrayElement([
                Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
                  () => ({
                    id: faker.string.uuid(),
                    document_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    document_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    document_version: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    record_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    record_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    record_description: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    record_citation_reason: faker.string.alpha({ length: { min: 10, max: 20 } }),
                    year: faker.number.int({ min: undefined, max: undefined }),
                    converse_score: faker.number.float({
                      min: undefined,
                      max: undefined,
                      fractionDigits: 2,
                    }),
                    is_user_selected: faker.helpers.arrayElement([
                      faker.datatype.boolean(),
                      undefined,
                    ]),
                  }),
                ),
                undefined,
              ]),
            }),
          ),
          undefined,
        ]),
        source: {
          type: faker.helpers.arrayElement(Object.values(ProjectSourceType)),
          euc: faker.helpers.arrayElement([
            {
              id: faker.string.uuid(),
              title: faker.string.alpha({ length: { min: 10, max: 20 } }),
              file_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
              euc_data_type: faker.helpers.arrayElement(Object.values(EucDataType)),
              fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
            },
            undefined,
          ]),
        },
      }),
    ),
  },
});

export const getCreateProjectResponseMock = (
  overrideResponse: Partial<ProjectCreateResponse> = {},
): ProjectCreateResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getCreateProjectTagResponseMock = (
  overrideResponse: Partial<IdResponse> = {},
): IdResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getUpdateProjectTagResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteProjectTagResponseMock = (): SuccessResponse => ({ success: true });

export const getBulkDeleteProjectsResponseMock = (): SuccessResponse => ({ success: true });

export const getBulkCreateProjectsFromEucResponseMock = (): SuccessResponse => ({ success: true });

export const getCreateBulkReferenceChatResponseMock = (): SuccessResponse => ({ success: true });

export const getBulkCreateReferenceMatchResponseMock = (): SuccessResponse => ({ success: true });

export const getUpdateReferenceMatchDocumentRecordResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetProjectEucsResponseMock = (
  overrideResponse: Partial<ProjectEucsListResponse> = {},
): ProjectEucsListResponse => ({
  items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    ...{
      id: faker.string.uuid(),
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      file_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      euc_data_type: faker.helpers.arrayElement(Object.values(EucDataType)),
      fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
    },
    ...{ project_count: faker.number.int({ min: 0, max: undefined }) },
  })),
  ...overrideResponse,
});

export const getGetProjectsOptionsResponseMock = (): ProjectsOptionsResponse => ({
  tags: [
    { id: '44444444-4444-4444-4444-444444444444', name: '重点施策' },
    { id: '44444444-4444-4444-4444-444444444448', name: 'デジタル化' },
  ],
});

export const getGetProjectsProjectIdResponseMock = (): ProjectDetailResponse => ({
  id: '55555555-5555-5555-5555-555555555555',
  source: {
    type: 'euc',
    euc: {
      id: 'e0c00001-0000-0000-0000-000000000001',
      title: 'R5年度 歳出データ',
      file_name: 'R5_expenditure_data.xlsx',
      euc_data_type: 'expenditure-record',
      fiscal_year: 2023,
    },
  },
  kan: {
    id: '00000002-0000-0000-0000-000000000002',
    accounting_type_id: '00000001-0000-0000-0000-000000000001',
    code: '02',
    name: '総務費',
  },
  ko: {
    id: '00020100-0000-0000-0000-000000020100',
    kan_id: '00000002-0000-0000-0000-000000000002',
    code: '01',
    name: '総務管理費',
  },
  moku: {
    id: '00020106-0000-0000-0000-000002010006',
    ko_id: '00020100-0000-0000-0000-000000020100',
    code: '06',
    name: '企画費',
  },
  saimoku_code: '',
  saimoku_name: '',
  saisaimoku_code: '',
  saisaimoku_name: '',
  project_code: '001',
  project_name: 'デジタル化推進事業',
  project_group_description: '',
  project_description:
    '行政手続きのオンライン化およびデータ活用基盤の整備を推進し、住民サービスの向上と業務効率化を図る。',
  budget_management_division: {
    id: '00000001-0000-0000-0000-000000000001',
    code: '',
    name: '企画財政課',
    year: 2025,
  },
  budget_amount: 50000000,
  budget_description: '',
  year: 2025,
  memo: '総務省デジタル田園都市国家構想交付金を活用予定',
  tags: [
    { id: '44444444-4444-4444-4444-444444444444', name: '重点施策' },
    { id: '44444444-4444-4444-4444-444444444448', name: 'デジタル化' },
  ],
  display_created_at: '2024-01-15T09:00:00Z',
  reference_chats: [
    {
      id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      type: 'special_allocation_taxes',
      completion: '特別交付税に関する参考情報です。',
    },
  ],
  reference_matches: [
    {
      reference_match_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      reference_chat_type: 'special_allocation_taxes',
      status: 'completed',
      converse_count: 1,
      documents: [
        {
          id: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
          document_id: 'doc-001',
          document_name: '特別交付税に関する省令',
          document_version: '令和7年4月1日改正',
          record_id: 'rec-001',
          record_name: '算定項目1',
          record_description: '算定項目の説明',
          record_citation_reason: '事業内容が合致するため',
          year: 2025,
          converse_score: 0.92,
          is_user_selected: true,
        },
      ],
    },
  ],
});

export const getUpdateProjectResponseMock = (
  overrideResponse: Partial<ProjectUpdateResponse> = {},
): ProjectUpdateResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getDeleteProjectResponseMock = (): DeleteProjectResponse => ({ success: true });

export const getGetProjectReferenceChatResponseMock = (): ProjectReferenceChatDetailResponse => ({
  chat_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  status: 'idle',
  rag_type: 'special_allocation_taxes',
  prompt: 'この事業の参考情報を教えてください',
  completion: 'この事業に関連する参考情報をご紹介します。',
  input: null,
  output: null,
});

export const getCreateProjectReferenceChatResponseMock = (): SuccessResponse => ({ success: true });

export const getCreateReferenceMatchResponseMock = (): IdResponse => ({
  id: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
});

export const getGetReferenceMatchResponseMock = (): ProjectReferenceMatchDetailResponse => ({
  reference_match_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  reference_chat_type: 'special_allocation_taxes',
  status: 'completed',
  converse_count: 2,
  documents: [
    {
      id: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
      document_id: 'doc-001',
      document_name: '特別交付税に関する省令',
      document_version: '令和7年4月1日改正',
      record_id: 'rec-001',
      record_name: '算定項目1',
      record_description: '算定項目の説明',
      record_citation_reason: '事業内容が合致するため',
      year: 2025,
      converse_score: 0.92,
      is_user_selected: true,
    },
    {
      id: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
      document_id: 'doc-002',
      document_name: '国庫補助金交付要綱',
      document_version: '令和6年4月1日制定',
      record_id: 'rec-002',
      record_name: '補助対象経費2',
      record_description: '補助対象経費の詳細説明',
      record_citation_reason: '事業区分が一致するため',
      year: 2024,
      converse_score: 0.78,
      is_user_selected: null,
    },
  ],
});

export const getListReferenceMatchDocumentRecordsResponseMock = (
  overrideResponse: Partial<ProjectReferenceMatchDocumentRecordListResponse> = {},
): ProjectReferenceMatchDocumentRecordListResponse => ({
  items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    record_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
    record_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    record_description: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    document_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
    document_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    document_version: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    year: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
      undefined,
    ]),
    projects: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        accounting_type: faker.helpers.arrayElement([
          {
            id: faker.string.uuid(),
            code: faker.string.alpha({ length: { min: 10, max: 50 } }),
            name: faker.string.alpha({ length: { min: 10, max: 255 } }),
            year: faker.number.int({ min: 1900, max: 2100 }),
          },
          undefined,
        ]),
        kan: {
          id: faker.string.uuid(),
          accounting_type_id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        },
        ko: {
          id: faker.string.uuid(),
          kan_id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        },
        moku: {
          id: faker.string.uuid(),
          ko_id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        },
        saimoku_code: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 50 } }),
          undefined,
        ]),
        saimoku_name: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 255 } }),
          undefined,
        ]),
        saisaimoku_code: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 50 } }),
          undefined,
        ]),
        saisaimoku_name: faker.helpers.arrayElement([
          faker.string.alpha({ length: { min: 10, max: 255 } }),
          undefined,
        ]),
        project_code: faker.string.alpha({ length: { min: 10, max: 50 } }),
        project_name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        budget_management_division: {
          id: faker.string.uuid(),
          code: faker.string.alpha({ length: { min: 10, max: 50 } }),
          name: faker.string.alpha({ length: { min: 10, max: 255 } }),
          year: faker.number.int({ min: 1900, max: 2100 }),
        },
        budget_amount: faker.number.int({ min: undefined, max: undefined }),
        year: faker.number.int({ min: 1900, max: 2100 }),
        created_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
        updated_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
        display_created_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          undefined,
        ]),
        tags: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            id: faker.string.uuid(),
            name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          }),
        ),
        source: {
          type: faker.helpers.arrayElement(Object.values(ProjectSourceType)),
          euc: faker.helpers.arrayElement([
            {
              id: faker.string.uuid(),
              title: faker.string.alpha({ length: { min: 10, max: 20 } }),
              file_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
              euc_data_type: faker.helpers.arrayElement(Object.values(EucDataType)),
              fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
            },
            undefined,
          ]),
        },
        record_citation_reason: faker.string.alpha({ length: { min: 10, max: 20 } }),
        converse_score: faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
        is_user_selected: faker.datatype.boolean(),
      }),
    ),
  })),
  count: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getListAgentChatThreadsResponseMock = (): ProjectAgentChatThreadListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        title: faker.string.alpha({ length: { min: 10, max: 20 } }),
        is_favorite: faker.datatype.boolean(),
        created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        last_message_at: faker.helpers.arrayElement([
          faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
          undefined,
        ]),
      }),
    ),
  },
});

export const getCreateAgentChatThreadResponseMock = (): IdResponse => ({
  id: '00000001-0000-0000-0000-000000000001',
});

export const getGetAgentChatThreadResponseMock = (
  overrideResponse: Partial<ProjectAgentChatThreadDetailResponse> = {},
): ProjectAgentChatThreadDetailResponse => ({
  id: faker.string.uuid(),
  title: faker.string.alpha({ length: { min: 10, max: 20 } }),
  is_favorite: faker.datatype.boolean(),
  created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  turns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    id: faker.string.uuid(),
    prompt: faker.string.alpha({ length: { min: 10, max: 20 } }),
    project_prompt: faker.string.alpha({ length: { min: 10, max: 20 } }),
    completion: faker.string.alpha({ length: { min: 10, max: 20 } }),
    status: faker.helpers.arrayElement([
      'idle',
      'generating',
      'completed',
      'failed',
      'deleted',
    ] as const),
    template_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  })),
  ...overrideResponse,
});

export const getUpdateAgentChatThreadResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteAgentChatThreadResponseMock = (): SuccessResponse => ({ success: true });

export const getToggleAgentChatThreadFavoriteResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getCreateAgentChatTurnResponseMock = (): IdResponse => ({
  id: '00000001-0000-0000-0000-000000000001',
});

export const getGetAgentChatTurnResponseMock = (): ProjectAgentChatTurnDetailResponse => ({
  ...{
    id: faker.string.uuid(),
    prompt: faker.string.alpha({ length: { min: 10, max: 20 } }),
    project_prompt: faker.string.alpha({ length: { min: 10, max: 20 } }),
    completion: faker.string.alpha({ length: { min: 10, max: 20 } }),
    status: faker.helpers.arrayElement([
      'idle',
      'generating',
      'completed',
      'failed',
      'deleted',
    ] as const),
    template_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
      undefined,
    ]),
    created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  },
});

export const getListProjectMemosResponseMock = (): ProjectMemoListResponse => ({
  count: 2,
  items: [
    {
      id: '00000001-0000-0000-0000-000000000001',
      body_preview: '# メモタイトル\n\n本文の内容です。これはプレビュー...',
      created_at: '2026-01-20T06:23:32.673Z',
      updated_at: '2026-01-20T06:23:32.673Z',
      project_agent_chat_threads: [],
    },
    {
      id: '00000002-0000-0000-0000-000000000002',
      body_preview: 'AIチャットから保存したメモです。',
      created_at: '2026-01-19T10:00:00.000Z',
      updated_at: '2026-01-19T10:00:00.000Z',
      project_agent_chat_threads: [
        { id: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa', title: '予算計画の相談', deleted_at: null },
      ],
    },
  ],
});

export const getCreateProjectMemoResponseMock = (): IdResponse => ({
  id: '00000001-0000-0000-0000-000000000001',
});

export const getGetProjectMemoResponseMock = (): ProjectMemoDetailResponse => ({
  id: '00000001-0000-0000-0000-000000000001',
  body: '# メモタイトル\n\n本文の内容です。Markdown形式で記述できます。\n\n- リスト1\n- リスト2',
  created_at: '2026-01-20T06:23:32.673Z',
  updated_at: '2026-01-20T06:23:32.673Z',
  project_agent_chat_threads: [],
});

export const getUpdateProjectMemoResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteProjectMemoResponseMock = (): SuccessResponse => ({ success: true });

export const getCreateProjectTagProjectResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteProjectTagProjectResponseMock = (): SuccessResponse => ({ success: true });

export const getCreateProjectQueryStoreResponseMock = (
  overrideResponse: Partial<IdResponse> = {},
): IdResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getGetProjectQueryStoreQueryStoreIdResponseMock =
  (): ProjectListQueryStoreDetailResponse => ({
    id: '0a5e0000-0000-0000-0000-000000000001',
    query: {
      year: 2025,
      project_name: 'デジタル化推進事業',
      budget_management_division_ids: ['00000001-2023-0000-0000-000000000001'],
      euc_import_master_id: 'e0c00013-0000-0000-0000-000000000013',
      tag_ids: ['44444444-4444-4444-4444-444444444444'],
      accounting_type_id: '17cd0e90-8acc-4632-9c77-fccd1c4f0d99',
      kan_ids: ['00000002-0000-0000-0000-000000000002'],
      ko_ids: ['00020100-0000-0000-0000-000000020100'],
      moku_ids: ['00020101-0000-0000-0000-000002010001'],
      reference_match_document_record_record_id: 'rec-001',
      reference_match_document_record_document_id: 'doc-001',
      has_reference_match: true,
    },
  });

export const getGetProjectsMockHandler = (
  overrideResponse?:
    | PagedProjectListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedProjectListResponse> | PagedProjectListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateProjectMockHandler = (
  overrideResponse?:
    | ProjectCreateResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<ProjectCreateResponse> | ProjectCreateResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateProjectTagMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/project-tags',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectTagResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateProjectTagMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/project-tags/:tagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateProjectTagResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteProjectTagMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/project-tags/:tagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteProjectTagResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getBulkDeleteProjectsMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/bulk/delete',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBulkDeleteProjectsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getBulkCreateProjectsFromEucMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/bulk-create/euc/:eucImportMasterId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBulkCreateProjectsFromEucResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateBulkReferenceChatMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/reference_chats/:referenceChatType/bulk',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateBulkReferenceChatResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getBulkCreateReferenceMatchMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/reference-matches/bulk',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBulkCreateReferenceMatchResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateReferenceMatchDocumentRecordMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/projects/reference-matches/document-records/:documentRecordId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateReferenceMatchDocumentRecordResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetProjectEucsMockHandler = (
  overrideResponse?:
    | ProjectEucsListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectEucsListResponse> | ProjectEucsListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/eucs',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectEucsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetProjectsOptionsMockHandler = (
  overrideResponse?:
    | ProjectsOptionsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectsOptionsResponse> | ProjectsOptionsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/options',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectsOptionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetProjectsProjectIdMockHandler = (
  overrideResponse?:
    | ProjectDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectDetailResponse> | ProjectDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectsProjectIdResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateProjectMockHandler = (
  overrideResponse?:
    | ProjectUpdateResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<ProjectUpdateResponse> | ProjectUpdateResponse),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/projects/:projectId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateProjectResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteProjectMockHandler = (
  overrideResponse?:
    | DeleteProjectResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<DeleteProjectResponse> | DeleteProjectResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/projects/:projectId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteProjectResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetProjectReferenceChatMockHandler = (
  overrideResponse?:
    | ProjectReferenceChatDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectReferenceChatDetailResponse> | ProjectReferenceChatDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/references/chats/:referenceChatType',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectReferenceChatResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateProjectReferenceChatMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/:projectId/references/chats/:referenceChatType',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectReferenceChatResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateReferenceMatchMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/:projectId/reference-matches',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateReferenceMatchResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetReferenceMatchMockHandler = (
  overrideResponse?:
    | ProjectReferenceMatchDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectReferenceMatchDetailResponse> | ProjectReferenceMatchDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/reference-matches/:referenceChatType',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetReferenceMatchResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListReferenceMatchDocumentRecordsMockHandler = (
  overrideResponse?:
    | ProjectReferenceMatchDocumentRecordListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<ProjectReferenceMatchDocumentRecordListResponse>
        | ProjectReferenceMatchDocumentRecordListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/reference-matches/document-records',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListReferenceMatchDocumentRecordsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListAgentChatThreadsMockHandler = (
  overrideResponse?:
    | ProjectAgentChatThreadListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectAgentChatThreadListResponse> | ProjectAgentChatThreadListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/agent-chat-threads',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListAgentChatThreadsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAgentChatThreadMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/:projectId/agent-chat-threads',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAgentChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetAgentChatThreadMockHandler = (
  overrideResponse?:
    | ProjectAgentChatThreadDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectAgentChatThreadDetailResponse> | ProjectAgentChatThreadDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/agent-chat-threads/:threadId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAgentChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateAgentChatThreadMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/projects/:projectId/agent-chat-threads/:threadId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateAgentChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteAgentChatThreadMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/projects/:projectId/agent-chat-threads/:threadId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteAgentChatThreadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getToggleAgentChatThreadFavoriteMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/projects/:projectId/agent-chat-threads/:threadId/favorite',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getToggleAgentChatThreadFavoriteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAgentChatTurnMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/:projectId/agent-chat-threads/:threadId/turns',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAgentChatTurnResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetAgentChatTurnMockHandler = (
  overrideResponse?:
    | ProjectAgentChatTurnDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectAgentChatTurnDetailResponse> | ProjectAgentChatTurnDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/agent-chat-threads/:threadId/turns/:turnId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAgentChatTurnResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListProjectMemosMockHandler = (
  overrideResponse?:
    | ProjectMemoListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectMemoListResponse> | ProjectMemoListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/memos',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListProjectMemosResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateProjectMemoMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/:projectId/memos',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectMemoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetProjectMemoMockHandler = (
  overrideResponse?:
    | ProjectMemoDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectMemoDetailResponse> | ProjectMemoDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/projects/:projectId/memos/:memoId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectMemoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateProjectMemoMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/projects/:projectId/memos/:memoId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateProjectMemoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteProjectMemoMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/projects/:projectId/memos/:memoId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteProjectMemoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateProjectTagProjectMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/:projectId/tags/:tagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectTagProjectResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteProjectTagProjectMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/projects/:projectId/tags/:tagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteProjectTagProjectResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateProjectQueryStoreMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/project-query-stores',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectQueryStoreResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetProjectQueryStoreQueryStoreIdMockHandler = (
  overrideResponse?:
    | ProjectListQueryStoreDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProjectListQueryStoreDetailResponse> | ProjectListQueryStoreDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/project-query-stores/:queryStoreId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProjectQueryStoreQueryStoreIdResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetProjectsMockHandler(),
  getCreateProjectMockHandler(),
  getCreateProjectTagMockHandler(),
  getUpdateProjectTagMockHandler(),
  getDeleteProjectTagMockHandler(),
  getBulkDeleteProjectsMockHandler(),
  getBulkCreateProjectsFromEucMockHandler(),
  getCreateBulkReferenceChatMockHandler(),
  getBulkCreateReferenceMatchMockHandler(),
  getUpdateReferenceMatchDocumentRecordMockHandler(),
  getGetProjectEucsMockHandler(),
  getGetProjectsOptionsMockHandler(),
  getGetProjectsProjectIdMockHandler(),
  getUpdateProjectMockHandler(),
  getDeleteProjectMockHandler(),
  getGetProjectReferenceChatMockHandler(),
  getCreateProjectReferenceChatMockHandler(),
  getCreateReferenceMatchMockHandler(),
  getGetReferenceMatchMockHandler(),
  getListReferenceMatchDocumentRecordsMockHandler(),
  getListAgentChatThreadsMockHandler(),
  getCreateAgentChatThreadMockHandler(),
  getGetAgentChatThreadMockHandler(),
  getUpdateAgentChatThreadMockHandler(),
  getDeleteAgentChatThreadMockHandler(),
  getToggleAgentChatThreadFavoriteMockHandler(),
  getCreateAgentChatTurnMockHandler(),
  getGetAgentChatTurnMockHandler(),
  getListProjectMemosMockHandler(),
  getCreateProjectMemoMockHandler(),
  getGetProjectMemoMockHandler(),
  getUpdateProjectMemoMockHandler(),
  getDeleteProjectMemoMockHandler(),
  getCreateProjectTagProjectMockHandler(),
  getDeleteProjectTagProjectMockHandler(),
  getCreateProjectQueryStoreMockHandler(),
  getGetProjectQueryStoreQueryStoreIdMockHandler(),
];
